import { useParams } from "react-router-dom";
import { useContext, useEffect } from "react";
import { ThemeContext } from "../../../Context/ThemeContext";
import { ScrollContext } from "../../../Context/ScrollContext";
import { AiFillGithub as Github } from "react-icons/ai";

const SingleProject = () => {
  const { id } = useParams();
  const { SingleProjectRef, changeLocation } = useContext(ScrollContext);
  const { setPath } = useContext(ThemeContext);
  useEffect(() => {
    changeLocation(SingleProjectRef);
    window.onpopstate = () => {
      setPath("/");
    };
  }, [id]);

  const PROJECTS = {
    projectArr: ["savvyard", "spytechwear"],
    savvyard: {
      imgSrc: "/images/savvyard.png",
      imgDesc: "mobile version of project: ",
      title: "Savvyard",
      github: "https://github.com/visionspider/savvyard",
      youtube: "https://www.youtube.com/embed/KgrU0RVNfMo",
      img1: "/images/savvyard-large.png",
      img2: "/images/savvyard-large2.png",
      img3: "/images/savvyard-large3.png",
      img4: "/images/savvyard-large4.png",
      intro:
        "Savvyard is meant to be an aid for greenhouse monitoring. Usually smart greenhouses are automated. Meaning self-sufficient for the most part. But things don't always go right. Thats where Savvyard comes to the rescue. With Savvyard you can monitor greenhouse activities from a distance and keep that peace of mind while enjoying your life.",
      technologies: "React, Javascript, CSS, Node, Express, MongoDB",
      motivation:
        "Personally I have a passion for off-grid living and have looked extensively into greenhouses / aquaponics / hydroponics projects of others. As someone who also enjoys traveling I would like a way to monitor my plant babies while I am gone. As a compliment to those who have such products, a nice UI that could help share information and manipulate devices while one is away (traveling / etc…). This is my goal to achieve with this UI.",
      features:
        "Being able to add/remove an infinite amount of devices/sensors/zones._Being able to manually turn on controls on a sensor/device._Being able to visualize data on the screen._Being able to download data.",
      design: "When designing I took inspiration off of apps for smart homes.",
      issues:
        "Creating the feature of adding and removing an infinite amount of devices/sensors/zones. Working with data that is nested deep into a data set.",
    },
    spytechwear: {
      imgSrc: "/images/spytechwear.png",
      imgDesc: "mobile version of project: ",
      title: "Spy Tech Wear",
      github: "https://github.com/visionspider/Spy-Tech-Wear",
      img1: "/images/spytechwear-large.png",
      img2: "/images/spytechwear-large2.png",
      img3: "/images/spytechwear-large3.png",
      intro:
        "Spy Tech Wear is a e-commerce for secret agents who are looking to buy smart wearable devices.",
      technologies: "React, Javascript, CSS, Node, Express, MongoDB",
      motivation:
        "Group project with fellow students, we had a deadline of 5 days to build and present the project.",
      features:
        "Being able to match any search relative to the data of our products._An interactive shopping cart._Form validation.",
      design:
        "When designing we took inspiration from Amazon and tried to theme it on espionage movies.",
      issues:
        "Working in a team can be difficult as you can't just jump into working on something without checking in with other people. We had solved this by dividing task on a kanban board.",
    },
  };
  const {
    youtube = false,
    imgDesc = false,
    imgSrc = false,
    img1 = false,
    img2 = false,
    img3 = false,
    img4 = false,
    title = false,
    github = false,
    intro = false,
    technologies = false,
    motivation = false,
    features = false,
    design = false,
    issues = false,
  } = PROJECTS[id];
  const featureList = features.split("_");
  return (
    <div className="single-project-container" ref={SingleProjectRef}>
      <h2>{title}</h2>
      <a
        href={github}
        target="_blank"
        rel="noreferrer"
        className="transparent-btn btn-hover"
      >
        <Github /> Github
      </a>
      <h3>Intro</h3>
      <p>{intro}</p>
      <img src={img1} alt={imgDesc} height={"50%"} width={"50%"} />
      <h3>Technologies used</h3>
      <p>{technologies}</p>
      <img src={img2} alt={imgDesc} height={"50%"} width={"50%"} />
      <h3>Motivation</h3>
      <p>{motivation}</p>
      <img src={img3} alt={imgDesc} height={"50%"} width={"50%"} />
      <h3>Features</h3>
      <ul>
        {featureList.map((feature) => (
          <li key={feature}>{feature}</li>
        ))}
      </ul>
      <h3>Design</h3>
      <p>{design}</p>
      <h3>Issues</h3>
      <p>{issues}</p>
      {youtube !== false && (
        <div className="video-wrap">
          <div className="video-container">
            <iframe
              width="560"
              height="315"
              src={youtube}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleProject;
